export default {
  'statements.editSettings': 'Edit Statement Settings',
  'statements.header': 'Statements and Reports',
  'statements.period': 'Statement Period',
  'statements.maxLength': 'You can only select <%=maxLength %> accounts at a time.',
  'statements.partialResult':
    'Partial result. One or more Statements within your request is not found.',
  'statements.maxRange': 'Maximum range is <%=months + 1 %> months',
  'statements.from.month': 'From Month',
  'statements.from.year': 'From Year',
  'statements.to.month': 'To Month',
  'statements.to.year': 'To Year',
  'statement.quickRange': 'Quick Range',
  'statement.quickRangeSelector': 'Quick date range selected. Click to enter a custom date range',
  'statement.customRangeSelector':
    'Custom date range selected. Click to enter a quick date range option'
};
